import React, { useEffect, useState } from "react";
import styles from "./Footer.module.scss";
import Image from "next/future/image";
import { buildApiUrl } from "src/helpers/imageHelpers";

import Link from "next/link";

import Facebook from "../../../svg/facebook.svg";
import Instagram from "../../../svg/instagram.svg";
import Twitter from "../../../svg/twitter.svg";
import Snapshot from "../../../svg/snapshot.svg";
import Youtube from "../../../svg/youtube.svg";
import Phone from "../../../svg/ic-mobile1.svg";
import Massage from "../../../svg/ic-envelope1.svg";
import Location from "../../../svg/location1.svg";
import IcTicktok from "../../../svg/ic-ticktok.svg";
import Linkedin from "../../../svg/linkedin.svg";
import Logo from "../../../svg/logo.svg";
import IcTabby from "../../../svg/ic-tabby.svg";
import IcTammara from "../../../svg/ic-tammara.svg";
import Icvisa from "../../../svg/ic-visa.svg";
import IcApplePay from "../../../svg/ic-applePay.svg";
import IcMasterCard from "../../../svg/ic-mastercard.svg";
import Ejjadh from "../../../assets/images/ejjadh.svg";
import Clock from "../../../svg/clock1.svg";
import XIcon from "../../../svg/x.svg";

import server from "src/api/server";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import { Col, Container, Row } from "react-bootstrap";
export default function Footer() {
  const [data, setData] = useState({});
  const [servicesData, setServicesData] = useState([]);
  const [profilePost, setProfilePost] = useState(null);
  const { locale } = useRouter();
  const paymesnts = [IcTabby, IcTammara, Icvisa, IcApplePay, IcMasterCard];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [footerRes, servicesRes, profileRes] = await Promise.all([
          server.get("/api/footer"),
          server.get("/api/services"),
          server.get("/api/posts/656"),
        ]);

        setData(footerRes?.data?.data || {});
        setProfilePost(profileRes?.data?.data || null);

        const raw = servicesRes?.data?.data?.services;
        setServicesData(Array.isArray(raw) ? raw : []);
      } catch (error) {
        console.error("Failed to fetch footer data:", error);
      }
    };

    fetchData();
  }, []);
  const router = useRouter();
  const { locale: lang } = router;

  return (
    <footer
      className={styles.footer}
      style={{
        backgroundImage: `url(${process.env.NEXT_PUBLIC_API_URL}/${data?.AppSetting?.footerImage}) `,
      }}
    >
      {profilePost?.data?.file && (
        <Container>
          <div className={styles["profile-banner"]}>
            <div className={styles["profile-banner__inner"]}>
              <h2 className={styles["profile-banner__title"]}>
                {profilePost?.data?.title?.[lang]}
              </h2>
              <a
                href={profilePost?.data?.file}
                download
                target="_blank"
                rel="noreferrer"
                className={styles["profile-banner__btn"]}
              >
                <FormattedMessage id="download-description" />

                <span className={styles["profile-banner__btn-icon"]}>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.53577 3.53556L14.1424 14.1422"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </a>
            </div>
          </div>
        </Container>
      )}
      <Container>
        <Row className={`gy-4 ${styles["footer-main-row"]}`}>
          <Col xs={12} md={12} lg={3}>
            <div className="flex-col">
              {data?.AppSetting?.appLogo && (
                <Link href="/">
                  <a className="logo">
                    <Image
                      src={buildApiUrl(data?.AppSetting?.appLogo) || Logo}
                      alt={"logo"}
                      width={1920}
                      height={1080}
                      priority={true}
                      sizes="100%"
                    />
                  </a>
                </Link>
              )}
              {locale === "ar" && data?.AppSetting?.appDesc && (
                <p> {data?.AppSetting?.appDesc}</p>
              )}
              {locale === "en" && data?.AppSetting?.appDesc_EN && (
                <p> {data?.AppSetting?.appDesc_EN}</p>
              )}
            </div>
            <div className="flex-between-col">
              <div className="logos">
                {data?.socials?.facebook && (
                  <span>
                    <Link href={data?.socials?.facebook}>
                      <a aria-label="facebook" target="_blank" rel="noreferrer">
                        <Facebook />
                      </a>
                    </Link>
                  </span>
                )}
                {data?.socials?.twitter && (
                  <span>
                    <Link href={data?.socials?.twitter}>
                      <a aria-label="twitter" target="_blank" rel="noreferrer">
                        <XIcon />
                      </a>
                    </Link>
                  </span>
                )}
                {data?.socials?.ticktok && (
                  <span>
                    <Link href={data?.socials?.ticktok}>
                      <a aria-label="ticktock" target="_blank" rel="noreferrer">
                        <IcTicktok />
                      </a>
                    </Link>
                  </span>
                )}
                {data?.socials?.snapchat && (
                  <span>
                    <Link href={data?.socials?.snapchat}>
                      <a aria-label="snapchat" target="_blank" rel="noreferrer">
                        <Snapshot />
                      </a>
                    </Link>
                  </span>
                )}
                {data?.socials?.instagram && (
                  <span>
                    <Link href={data?.socials?.instagram}>
                      <a
                        aria-label="instagram"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Instagram />
                      </a>
                    </Link>
                  </span>
                )}
                {data?.socials?.youtube && (
                  <span>
                    <Link href={data?.socials?.youtube}>
                      <a aria-label="youtube" target="_blank" rel="noreferrer">
                        <Youtube />
                      </a>
                    </Link>
                  </span>
                )}
                {data?.socials?.linkedin && (
                  <span>
                    <Link href={data?.socials?.linkedin}>
                      <a aria-label="linkedin" target="_blank" rel="noreferrer">
                        <Linkedin />
                      </a>
                    </Link>
                  </span>
                )}
              </div>
            </div>
          </Col>

          <Col xs={12} sm={12} md={12} lg={3}>
            <div className="links">
              <h3 className="h3">
                <FormattedMessage id="links" />
              </h3>
              <div>
                <ul>
                  <li>
                    <Link href="/">
                      <a className="custom-link">
                        <FormattedMessage id="home" />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/aboutus">
                      <a className="custom-link">
                        <FormattedMessage id="about" />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/services">
                      <a className="custom-link">
                        <FormattedMessage id="services" />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/ourworks">
                      <a className="custom-link">
                        <FormattedMessage id="our-works" />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/contactus">
                      <a className="custom-link">
                        <FormattedMessage id="contact-us" />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/policies">
                      <a className="custom-link">
                        <FormattedMessage id="policies" />
                      </a>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Col>

          <Col xs={12} sm={12} md={12} lg={3}>
            <div className="links links--stack">
              <h3 className="h3">
                <FormattedMessage id="our-services" />
              </h3>
              <div>
                <ul>
                  {servicesData?.slice(0, 4).map((item, index) => (
                    <li key={index}>
                      <Link href={`/services/${item?.slug}`}>
                        <a className="custom-link">{item?.title?.[locale]}</a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>

          <Col xs={12} md={12} lg={3}>
            <div className="flex-col">
              <h3 className="h3">
                <FormattedMessage id="adress" />
              </h3>
              <div className="item">
                <span
                  className="icon"
                  style={{
                    width: "40px",
                    height: "40px",
                    background: "#FFFFFF1A",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                {lang === "ar"
                  ? data?.socials?.address
                  : data?.socials?.address_EN}
              </div>

              {data?.AppSetting?.work_time && (
                <div className="item">
                  <span
                    className="icon"
                    style={{
                      width: "40px",
                      height: "40px",
                      background: "#FFFFFF1A",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="9" />
                      <path d="M12 7v5l3 2" />
                    </svg>
                  </span>
                  <p>{data?.AppSetting?.work_time}</p>
                </div>
              )}

              {data?.socials?.phone && (
                <div className="item">
                  <span
                    className="icon"
                    style={{
                      width: "40px",
                      height: "40px",
                      background: "#FFFFFF1A",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3.08 5.18 2 2 0 0 1 5.06 3h3a2 2 0 0 1 2 1.72l.45 3a2 2 0 0 1-.57 1.73L8.09 11.91a16 16 0 0 0 4 4l2.46-1.85a2 2 0 0 1 1.73-.57l3 .45A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </span>
                  <Link
                    href={`tel:${data?.socials?.phone.split(" ").join("")}`}
                  >
                    <a className="phone">{data?.socials?.phone}</a>
                  </Link>
                </div>
              )}

              {data?.socials?.email && (
                <div className="item">
                  <span
                    className="icon"
                    style={{
                      width: "40px",
                      height: "40px",
                      background: "#FFFFFF1A",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <Massage width={18} height={18} />
                  </span>
                  <Link href={`mailto:${data?.socials?.email}`} target="_blank">
                    <a>{data?.socials?.email} </a>
                  </Link>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <hr className="divider" />

      <Container>
        <div className="rights-payments">
          <div className="rights">
            <p>
              <FormattedMessage id="rights" />
            </p>
            <div className="dev-logo">
              <Link href="https://ejjadh.sa/" target="_blank" rel="noreferrer">
                <a aria-label="ejjadh icon">
                  <Ejjadh width={70} height={40} />
                </a>
              </Link>
            </div>
          </div>
          {/* <div className="paymesnts">
            {paymesnts.map((Item, index) => (
              <div key={index} className="payment">
                <Item />
              </div>
            ))}
          </div> */}
        </div>
      </Container>
    </footer>
  );
}
